import React, { ReactNode } from 'react';
import className from 'classnames';

import styles from '../navbar.scss';

interface OwnProps {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
  main?: ReactNode;
  customClassName?: string;
}

type Props = OwnProps;

export const MobileNavBarScaffold: React.FC<Props> = ({
  left,
  center,
  right,
  main,
  customClassName = ''
}): JSX.Element => (
  <div className={className('is-hidden-desktop', styles.flexSingle, customClassName)}>
    {main && main}
    {left && <section className={styles.leftSection}>{left}</section>}
    {center && <section className={styles.centerSection}>{center}</section>}
    {right && (
      <section className={styles.rightSection} style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
        {right}
      </section>
    )}
  </div>
);
